document.addEventListener("DOMContentLoaded", function (event) {
  window.setHubspotData = function () {
    function setHubspotValues() {
      var data = formData || {};
      var subject = data.subject || "";
      var level = data.level || "";
      var intent = data.intent || "";
      var timeslots = data.timeslots || "";

      if (subject && subject.toLowerCase().trim() === "mathematik") {
        subject = "Mathe";
      }

      setTimeout(function () {
        if ($('input[name="schulstufe"]').length > 0)
          $('input[name="schulstufe"]').val(level).change();
        if ($(".hs_intent").find("input").length > 0)
          $(".hs_intent").find("input").val(intent.join(", ")).change();
        if ($(".hs_timeframe").find("input").length > 0)
          $(".hs_timeframe").find("input").val(timeslots).change();
        if ($('input[name="trial_session_subject"]').length > 0)
          $('input[name="trial_session_subject"]').val(subject).change();
      }, 2000);
    }

    setHubspotValues();
  };
});
